/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EditorSuggestionTargetType {
    Base = '0',
    ByContact = 1,
    ByFunction = 2,
}
